import React, { useEffect } from 'react';
import { Box, Container, makeStyles, Grid, Card } from '@material-ui/core';
import {
  BackNavAdmin,
  ChallengeCreateCard,
  ChallengeImageCard,
  ChallengeCriteriaCard,
  ChallengeProgressCard,
  ChallengeAwardCard,
  ChallengeDatesCard,
} from '../../components';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { challengeActions } from '../../actions';
import config from '../../config';

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    marginTop: theme.spacing(3),
  },
  card: {
    padding: theme.spacing(4),
    borderRadius: 8,
    border: `1px solid ${theme.palette.neutrals.low.lightest}`,
    display: 'flex',
    flexDirection: 'column',
    gap: 30
  },
  fixed: {
    position: 'sticky',
    boxSizing: 'border-box',
    top: '76px',
  },
  spacing: {
  }
}));

export function ChallengeNewPage() {
  const classes = useStyles();
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const {
    newChallenge: {
      rewards,
      name,
      description,
      goal,
      requirement,
      startDate,
      dueDate,
      resultDate,
      thumbnail,
      banner
    },
    progress,
    newChallenge,
    loading
  } = useSelector((state) => state.challenge);

  useEffect(() => {
    dispatch(challengeActions.clearProgress());
  }, [])

  const shouldDisable = (
    !!name?.length &&
    description?.length > 100 &&
    !!requirement?.length &&
    !!goal?.length
  );

  return (
    <>
      <BackNavAdmin title={t('novo_desafio')}></BackNavAdmin>
      <Container maxWidth="lg" className={classes.root}>
        <Grid container spacing={3}>
          <Grid item xs={9}>
            <Box display="flex" flexDirection="column" style={{ gap: 20 }}>
              <ChallengeCreateCard
                name={name}
                description={description}
                goal={goal}
              />

              <Card elevation={0} className={classes.card}>
                <ChallengeImageCard type="thumbnail" imagem={thumbnail} />
                <ChallengeImageCard type="banner" imagem={banner} />
              </Card>

              <ChallengeCriteriaCard requirement={requirement} />

              <ChallengeDatesCard
                startDate={startDate}
                dueDate={dueDate}
                resultDate={resultDate}
              />

              {config.SHOW_REWARD_FIELDS_ON_CHALLENGE && (
                <ChallengeAwardCard rewards={rewards} />
              )}
            </Box>
          </Grid>
          <Grid item xs={3}>
            <Box className={classes.fixed}>
              <ChallengeProgressCard
                progress={progress}
                challenge={newChallenge}
                loading={loading}
                shouldDisable={!shouldDisable}
              />
            </Box>
          </Grid>
        </Grid>
      </Container>
    </>
  );
}